import { FC } from "react";
import { Redirect } from "react-router-dom";

import { usePermissionsContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";
import { useBandRoute } from "Bands/utils";

export const PermissionsOverviewPage: FC = () => {
  const { rootGroups } = usePermissionsContext();
  const { getPath } = useBandRoute();

  if (!rootGroups) return null;

  return (
    <Redirect
      to={getPath(BAND_PATHS.PERMISSION_GROUP, {
        params: { groupId: rootGroups[0].id },
      })}
    />
  );
};
